import { blankless } from '@js/dom/parent';

// `home-blank` is a curtain, not a destination: it hides the screen that finished while the host
// navigates. On a host that swaps the whole document there is no screen to hide, and dropping the
// curtain only flashes.
export default function blank(to) {
  if (to.name !== 'home-blank') {
    return true;
  }

  return !blankless();
}
